var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgImage = function SvgImage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M22 4.5A2.5 2.5 0 0 0 19.5 2h-15A2.5 2.5 0 0 0 2 4.5v15A2.5 2.5 0 0 0 4.5 22h15a2.5 2.5 0 0 0 2.5-2.5zm-1.667 15a.834.834 0 0 1-.833.833h-15a.834.834 0 0 1-.833-.833v-15a.833.833 0 0 1 .833-.833h15a.833.833 0 0 1 .833.833z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M5.333 8.667A1.667 1.667 0 0 0 7 10.333h2.5a2.5 2.5 0 0 0 0-5 2.5 2.5 0 0 0-2.3 1.534A.21.21 0 0 1 7 7a1.6 1.6 0 0 0-.942.292 1.67 1.67 0 0 0-.725 1.375M5.558 18.85a.417.417 0 0 1-.325-.675l2.325-3.025a1.55 1.55 0 0 1 2.217-.167l1.542 1.892a.425.425 0 0 0 .526.098.4.4 0 0 0 .14-.131l2.409-3.534a1.291 1.291 0 0 1 2.275.075L19.1 18.25a.4.4 0 0 1-.35.6z"
  })));
};
export default SvgImage;